import * as React from 'react';

import { Typography } from 'omakase';

interface IconProps {
  className: string;
}

interface Props {
  icon: React.ComponentClass<IconProps> | React.FunctionComponent<IconProps>;
  children?: React.ReactNode | React.ReactNodeArray;
}

const OfferingDetailsMetadataItem: React.FunctionComponent<Props> = ({
  children,
  icon: Icon,
  ...props
}) => (
  <li className="Consumer-reservationMetaItem">
    <Icon className="Consumer-reservationMetaItemIcon" />
    <Typography {...props} component="div" variant="body02" color="fgDefault">
      {children}
    </Typography>
  </li>
);

export default OfferingDetailsMetadataItem;
